import { Address } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';
import { useListBrandSettings } from '@frontend/api-brand-settings';
import { BusinessInfoQueries } from '@frontend/api-business-information';
import { useAppScopeSelection } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { determineLocationAddress } from './determine-location-address';
import { formatLocationAddress } from './format-location-address';
import { formatLocationAddressLink } from './format-location-address-link';

export const useLocationAddress = (selectedLocationId: string) => {
  const { selectedOrgId } = useAppScopeSelection();

  const { getFeatureFlagValue } = useAppFlagStore();
  const isBrandSettingsEnabled = getFeatureFlagValue({ locationIds: [selectedLocationId], flagName: 'brand-settings' });

  const { data: brandSettings = {} } = useListBrandSettings({
    locationIds: [selectedLocationId],
    orgId: selectedOrgId,
    queryOptions: {
      enabled: isBrandSettingsEnabled,
    },
  });
  const brandSettingAddress = brandSettings?.[selectedLocationId]?.locationAddress;

  const { data: businessData } = BusinessInfoQueries.useLocationTcrBrand(selectedLocationId);
  const tcrBrandAddress: Address = {
    address: businessData?.tcrBrand?.street,
    city: businessData?.tcrBrand?.city,
    state: businessData?.tcrBrand?.state,
    zipCode: businessData?.tcrBrand?.postalCode,
  };

  const determinedAddress = determineLocationAddress({
    brandSettingAddress,
    isBrandSettingsEnabled,
    tcrBrandAddress,
  });

  return {
    addressLink: formatLocationAddressLink(determinedAddress),
    humanReadableAddress: formatLocationAddress(determinedAddress),
    preferredAddress: determinedAddress,
  };
};
